var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataList',{attrs:{"categoryKey":"工厂"}})
}
var staticRenderFns = []

export { render, staticRenderFns }